<ph-dialog [open]="open" size="sm" heading="Review proposed change" (ph-close)="closed.emit(null)">
    <ph-stack>
        <ph-facts>
            <ph-fact>
                <ph-label>Operation</ph-label>
                <ph-toolbar nowrap>
                    <ph-badge variant="light" size="small" [color]="operationColor">{{ proposal.operation | uppercase }}</ph-badge>
                    <span>{{ proposal.modelClass }}</span>
                </ph-toolbar>
            </ph-fact>
            <ph-fact *ngIf="proposal.entityId !== null">
                <ph-label>Entity ID</ph-label>
                <div>{{ proposal.entityId }}</div>
            </ph-fact>
        </ph-facts>

        <div>{{ proposal.summary }}</div>

        <ng-container *ngIf="proposal.operation !== 'delete'">
            <ph-label>Payload</ph-label>
            <ph-rich-text size="sm" [markdown]="payloadMarkdown"></ph-rich-text>
        </ng-container>

        <ph-alert status="warning" size="small">
            Approving will commit this write to the database. Idempotent on retry.
        </ph-alert>
    </ph-stack>

    <ph-actions slot="footer" align="between">
        <ph-button variant="error" mode="stroke" (click)="onReject()">Reject</ph-button>
        <ph-toolbar>
            <ph-button variant="secondary" mode="filled" (click)="onCancel()">Cancel</ph-button>
            <ph-button (click)="onApprove()">Approve</ph-button>
        </ph-toolbar>
    </ph-actions>
</ph-dialog>
